import axios from 'axios';
let authenticated = localStorage.getItem("auth");
export const Axios = axios.create({
 baseURL: process.env.REACT_APP_API_URL,
 headers: {
 'Authorization': `Bearer ${authenticated}`, 
 // 'Content-Type': 'application/json',
 },
});
